import { render, staticRenderFns } from "./chart-statuses.vue?vue&type=template&id=a4b28e2a"
import script from "./chart-statuses.vue?vue&type=script&lang=ts"
export * from "./chart-statuses.vue?vue&type=script&lang=ts"
import style0 from "./chart-statuses.vue?vue&type=style&index=0&id=a4b28e2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports